.pce-fold {
	position: absolute;
	display: inline-grid;
	margin: 0 0 0 calc(2px - var(--_ns));
	width: calc(var(--_ns) - 2px);
	place-items: center;
	z-index: 2;
}

.pce-fold,
.pce-unfold span {
	pointer-events: auto;
	cursor: pointer;
}

.pce-fold > * {
	width: 0.7em;
}

.pce-fold > ::after {
	content: "";
	display: block;
	position: absolute;
	top: 50%;
	transform: translateY(-50%);
	height: 0.7em;
	width: 0.7em;
	background: var(--pce-bg-fold, #777);
	clip-path: polygon(6.36% 21.82%, 0% 28.18%, 50% 78.18%, 100% 28.18%, 93.64% 21.82%, 50% 65.45%);
}

.closed-fold > ::after {
	transform: translateY(-50%) rotate(-90deg);
}

.pce-nowrap .pce-fold {
	position: sticky;
	left: calc(2px + var(--padding-left) - var(--_ns));
}

.pce-unfold {
	position: absolute;
	padding-right: inherit;
	top: 0;
	color: #0000;
	z-index: 1;
}

.pce-unfold span {
	box-shadow: inset 0 0 0 1px var(--pce-widget-border);
	border-radius: 0.3em;
	background: repeat-x var(--pce-widget-bg) calc(1.5ch - 1.3px) 0.5em/0.85ch
		url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg"><circle fill="%23999" r="1.3" cx="1.3" cy="1.3"/></svg>');
}
